export default "__VITE_ASSET__Gsb0GKW$__"